
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'
const canUseDOM = !!(
  (typeof window !== 'undefined' &&
  window.document && window.document.createElement)
)

export const GoogleAnalyticsAPI = (...args) => {
  if (canUseDOM && window.ga) {
    window.ga.apply(null, args)
  }
}

export default class GoogleAnalytics extends React.Component {
  static propTypes = {
    appID: PropTypes.string
  }

  constructor(props) {
    super(props)

    const {appID} = props

    if (!appID || !canUseDOM) {
      return
    }

    if (!window.ga) {
      /*eslint-disable */
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
      /* eslint-enable */
    }

    if (window.ga) {
      window.ga('create', appID, 'auto')
      window.ga('send', 'pageview')
    }
  }

  shouldComponentUpdate() {
    return false
  }

  componentWillUnmount() {
    if (!canUseDOM) return false

    delete window.ga
  }

  render() {
    return false
  }
}



// WEBPACK FOOTER //
// ./client/components/GoogleAnalytics/index.js